"use client";

import { useMemo } from "react";

import type { QRProps } from "@/contexts/QREditorContext/types";
import { UseWifiDataResult, WifiTemplateTranslations } from "../types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";

export const useWifiData = (props: QRProps<"wifi">): UseWifiDataResult => {
  const { data, isInitPreview: isInitialPreview } = usePreviewData(props);

  const translations = props.previewTranslations?.["wifi"] as WifiTemplateTranslations;

  const wifiData = useMemo(() => {
    if (!data) {
      return {
        qrNetworkName: "",
        qrNetworkPassword: "",
        qrNetworkSecurityType: "",
        qrNetworkHidden: false,
      };
    }

    return {
      qrNetworkName: data.qrNetworkName ?? "",
      qrNetworkPassword: data.qrNetworkPassword ?? "",
      qrNetworkSecurityType: data.qrNetworkSecurityType ?? "",
      qrNetworkHidden: data.qrNetworkHidden ?? false,
    };
  }, [data]);

  return {
    translations,
    isInitialPreview,
    data,
    ...wifiData,
  };
};
